const BeyondRarity = ({ theme }) => {
	const color = theme === "dark" ? "#282d41" : "#fff";
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 281 26.24">
			<defs>
				<radialGradient
					id="b"
					cx="-677.98"
					cy="381.81"
					r="1"
					gradientTransform="translate(10191.12 -5647.94) scale(14.81)"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0" stopColor="#f99b20" />
					<stop offset="1" stopColor="#e0078c" />
				</radialGradient>
				<clipPath id="a">
					<path
						fill="none"
						d="M133.9 7.77l15.44 18.47V13.68a5.92 5.92 0 00-5.93-5.91h-9.51zm23.17 0a5.92 5.92 0 00-5.92 5.91v12.56l15.4-18.47zM139.93 0L134 5.92h9.33A5.93 5.93 0 00149.26 0zm11.25 0a5.93 5.93 0 005.92 5.92h9.33L160.51 0z"
					/>
				</clipPath>
			</defs>
			<g data-name="Layer 2">
				<g data-name="Layer 1">
					<g data-name="Layer 2">
						<g data-name="Layer 1-2">
							<path
								d="M236.62 2.76h3.64v12.69h-3.64zm39.45-.01l-5.5 4.91-5.51-4.91h-22.41v3.14h8.17v9.56h3.64V5.89h9.37l4.91 4.53v5.03h3.65v-5.01L281 2.75h-4.93zm-69.43 0h-7.79l-6.8 12.7h3.93l5.03-9.53h3.5l5.02 9.53h3.92l-6.81-12.7zm-15.77 4.1a4.12 4.12 0 00-4.1-4.1h-15.09a3.15 3.15 0 003.15 3.17h11.74a.93.93 0 110 1.86h-11.73a3.15 3.15 0 00-3.16 3.16v4.51h3.55v-4.51h8.23l2.67 4.51h4.21l-3-4.55a4.09 4.09 0 003.52-4.05m43.48 0a4.1 4.1 0 00-4.09-4.1h-15.1a3.17 3.17 0 003.17 3.17h11.75a.93.93 0 110 1.86h-11.73a3.15 3.15 0 00-3.17 3.15v4.51h3.55v-4.5H227l2.68 4.51h4.19l-3-4.55a4.09 4.09 0 003.52-4.05"
								fill={color}
							/>
							<g clipPath="url(#a)">
								<path fill="url(#b)" d="M133.9 0h32.65v26.24H133.9z" />
							</g>
							<path
								d="M39.64 12.29H25.5v-1.87h12.85V7.78H25.5V5.92h14.14V2.75H21.85v12.7h17.79v-3.16zm17.99-9.54l-5.5 4.57-5.51-4.57h-4.91l8.59 7.33v5.37h3.65V10.1l8.61-7.35h-4.93zm28.46 0v12.7h3.57V6.97l12.98 8.48h3.74V2.75h-3.56v8.49L89.84 2.75h-3.75zm-9-.22h-7.54c-4.11 0-7 2.7-7 6.57s2.88 6.57 7 6.57h7.54c4.11 0 7-2.7 7-6.57s-2.88-6.57-7-6.57m0 9.75h-7.54a3.13 3.13 0 01-3.27-3v-.19a3.11 3.11 0 013-3.2h7.77a3.13 3.13 0 013.25 3v.19a3.13 3.13 0 01-3.07 3.19h-.2m44.84-9.52h-13.09v12.7h13.09c4.19 0 7-2.55 7-6.35s-2.82-6.35-7-6.35m0 9.53h-9.48V5.92h9.47a3.18 3.18 0 110 6.36M19.84 6.59A3.84 3.84 0 0016 2.75H0v12.7h16a3.84 3.84 0 003.84-3.84 3.78 3.78 0 00-1-2.51 3.78 3.78 0 001-2.51m-4.65 5.69H3.56v-1.86h11.63a.93.93 0 010 1.86m0-4.5H3.56V5.92h11.63a.93.93 0 010 1.86"
								fill={color}
							/>
						</g>
					</g>
				</g>
			</g>
		</svg>
	);
};

export default BeyondRarity;
